module.exports = __webpack_public_path__ + "static/img/aiAvatar.237f433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/aiAvatar.png
// module id = 00wT
// module chunks = 4